import debug from 'debug';
type Debugger = ReturnType<typeof debug>;

const APP_NAMESPACE = 'dse';

/**
 * Enable debug output from a query string (?debug=...) by persisting to
 * localStorage so the `debug` library picks it up in the browser.
 */
function seedDebugFromQuery(): void {
  if (typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    const qsDebug = params.get('debug');
    if (!qsDebug) return;
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('debug', qsDebug);
    }
  } catch {
    // best-effort; ignore parsing/localStorage failures
  }
}

seedDebugFromQuery();

export interface Logger {
  debug: Debugger;
  info: Debugger;
  warn: Debugger;
  error: Debugger;
}

const namespace = (ns: string, level: string) => `${APP_NAMESPACE}:${ns}:${level}`;

/**
 * Create a namespaced logger that honors DEBUG env/ls and ?debug query param.
 */
export function createLogger(ns: string): Logger {
  return {
    debug: debug(namespace(ns, 'debug')),
    info: debug(namespace(ns, 'info')),
    warn: debug(namespace(ns, 'warn')),
    error: debug(namespace(ns, 'error')),
  };
}

